var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "100%" } },
    [
      _c("q-table", {
        ref: "logTable",
        staticClass: "sticky-header-table first-column-sticky",
        attrs: {
          data: _vm.tableData,
          columns: _vm.columns,
          "visible-columns": _vm.visibleColumns,
          pagination: _vm.pagination,
          "rows-per-page-options": _vm.rowsPerPageOptions,
          "pagination-label": _vm.getPaginationLabel,
          loading: _vm.loadingLogs,
          "row-key": "intPalletId"
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          },
          request: _vm.onRequest
        },
        scopedSlots: _vm._u([
          {
            key: "loading",
            fn: function() {
              return [
                _c("q-inner-loading", {
                  attrs: { showing: "", color: "primary" }
                })
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c("pallet-table-row", {
                  attrs: { props: props },
                  on: { showPalletLogList: _vm.showPalletLogList }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pallet-dialog", {
        attrs: {
          visible: _vm.showPalletDialog,
          name: _vm.name,
          pallet: _vm.pallet
        },
        on: {
          hide: function($event) {
            _vm.showPalletDialog = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }